import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import HeroSection from 'src/components/sections/hero'
import ContactSection from 'src/components/sections/ContactSection'
import { Link } from 'gatsby-plugin-react-i18next'
import ButtonIcon, { ButtonSizes } from 'src/components/ui/ButtonIcon'

import { getPageContent } from 'src/helpers/pageContent'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/iso', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }

  // Transform content to use H4 for the specific section
  const formattedContent = cmsJson.mainSection.content.replace(
    '<p>What is ISO 27001?<br />',
    '<h4>What is ISO 27001?</h4><p>'
  )

  // In CMS the title is provided as a single sentence (e.g. "Certified to ISO/IEC 27001").
  // Split after the word "to" so it breaks to a new line in the UI.
  const rawFirstPart = cmsJson.mainSection.firstPartOfTitle || ''
  const rawSecondPart = cmsJson.mainSection.secondPartOfTitle || ''
  const fullTitle = rawSecondPart ? `${rawFirstPart} ${rawSecondPart}`.trim() : rawFirstPart.trim()

  let firstPartOfTitle = rawFirstPart
  let secondPartOfTitle = rawSecondPart

  const toMatch = fullTitle.match(/^(.*?\bto\b)\s*(.*)$/i)
  if (toMatch) {
    firstPartOfTitle = toMatch[1]
    secondPartOfTitle = toMatch[2]
  }

  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas} isBottomMenuHidden={true}>
      <HeroSection
        translationContent={{
          subtitle: '',
          firstPartOfTitle,
          secondPartOfTitle,
          content: formattedContent,
          ctaLink: '',
          ctaText: '',
          sectionName: 'iso-hero',
        }}
        isFullHeight={false}
        useFormattedHtml={true}
        contentClassName="mt-6 md:mt-10"
        sectionClassName="mt-16 md:mt-colossal"
        beforeTitleContent={
          <Link to="/" className="hidden md:inline-block">
            <ButtonIcon
              size={ButtonSizes.large}
              morphingIcon="arrow-to-x"
            />
          </Link>
        }
        isH2={true}
      />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/iso" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
    }
  }
`

export default IndexPage
